import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded'
import { Badge, IconButton, Tooltip } from '@mui/material'
import { useFavourites } from 'core'
import { useNavigate } from 'react-router-dom'
import { PageURLs } from 'Routes'
import { useTheme } from '@mui/material'

const FavouritesButton = () => {
  const { favouritesQuantity } = useFavourites()
  const navigate = useNavigate()
  const theme = useTheme()

  return (
    <Tooltip title="Wishlist">
      <IconButton
        onClick={() => navigate(PageURLs.Favourites)}
        size="small"
        aria-label="Wishlist"
        sx={{
          color: theme.palette.text.primary,
          background: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)',
          borderRadius: '50%',
          width: 40,
          height: 40,
          transition: 'all 0.2s ease',
          '&:hover': {
            background: `${theme.palette.primary.main}18`,
            color: theme.palette.primary.main,
          },
        }}
      >
        <Badge badgeContent={favouritesQuantity} color="error" max={9}>
          <FavoriteBorderRoundedIcon sx={{ fontSize: 20 }} />
        </Badge>
      </IconButton>
    </Tooltip>
  )
}

export default FavouritesButton
